export default __webpack_public_path__ + "static/media/tenYard.eab3d405.jpg";